import React from 'react';
import { AlertCircle, WifiOff, Globe, Lock } from 'lucide-react';
import { useTranslation } from '../hooks/useTranslation';
import { Language } from '../translations';

interface ErrorMessageProps {
  message: string;
  language: Language;
}

export function ErrorMessage({ message, language }: ErrorMessageProps) {
  const { t } = useTranslation(language);

  if (!message) return null;

  const getIcon = () => {
    if (message.includes('internetverbinding') || message.includes('Network Error')) {
      return <WifiOff className="w-5 h-5 mt-0.5 flex-shrink-0" />;
    }
    if (message.includes('URL')) {
      return <Globe className="w-5 h-5 mt-0.5 flex-shrink-0" />;
    }
    if (message.includes('toegang') || message.includes('forbidden')) {
      return <Lock className="w-5 h-5 mt-0.5 flex-shrink-0" />;
    }
    return <AlertCircle className="w-5 h-5 mt-0.5 flex-shrink-0" />;
  };

  return (
    <div className="mt-6 p-4 bg-red-50 dark:bg-red-900/20 border border-red-200 dark:border-red-800 text-red-700 dark:text-red-200 rounded-lg flex items-start space-x-3">
      {getIcon()}
      <div>
        <h3 className="font-medium">{t('error', 'title')}</h3>
        <p className="text-sm mt-1">
          {message.includes('API key') 
            ? t('error', 'apiKey')
            : message}
        </p>
      </div>
    </div>
  );
}